import Marionette from 'backbone.marionette';
import billDetailVoteItemviewTmpl from '../templates/bill_detail_vote_itemview.tpl';
export default Marionette.ItemView.extend({
  template: billDetailVoteItemviewTmpl,
  tagName: "tr"
});